import React from 'react';
import { useTranslation } from 'react-i18next/';
import { useSelector } from 'react-redux';
import { RootState } from 'src/configs/store';

import './StakeSelection.scss';
import { formatAmountToFixed } from 'src/utils/utils';

function StakeSelection() {
  const slip = useSelector((state: RootState) => state.betslip.slip);
  const singleSlip = useSelector((state: RootState) => state.betslip.singleSlip);
  const accaSlip = useSelector((state: RootState) => state.betslip.accaSlip);
  const systemSlip = useSelector((state: RootState) => state.betslip.systemSlip);
  const totalAmount = useSelector((state: RootState) => state.betslip.totalAmount);

  const { t } = useTranslation();

  let selectedSlip = singleSlip;
  if (slip === 1) selectedSlip = accaSlip;
  else if (slip === 2) selectedSlip = systemSlip;

  const getStakeNaming = (key) => {
    if (key === 'sameStake' && slip === 1){
      return 'sameStakeAcca';
    } else if (key === 'differentStake' && slip === 2){
      return 'differentStakePerCombo';
    }
    return key;
  };

  return (
    <div className="stake-selection">
      {
        selectedSlip.stakeSelection !== 'differentStake' ?
          `${ t(`betslip.${  getStakeNaming(selectedSlip.stakeSelection) }`) } : ${
            formatAmountToFixed(selectedSlip[selectedSlip.stakeSelection], 100, true) }` :
          t(`betslip.${ getStakeNaming(selectedSlip.stakeSelection) }SecondScreen`) + formatAmountToFixed(totalAmount, 1, true)
      }
    </div>
  );
}

export default StakeSelection;
